/**
 * バイト数をギガバイトに変換する関数
 * @param fileSize バイト単位のファイルサイズの数値
 * @returns 小数点第三位まで表示するギガバイトのファイルサイズ
 */
export const convertByteToGigaByte = (fileSize: number) => {
  return (fileSize / 1e9).toFixed(3);
};
